import styled, { css } from "styled-components";

import { IStyleProps } from "./interfaces";
import { experienceEasterPath } from "../../../../paths";

export const ScoreWrapper = styled.div<IStyleProps>`
    overflow: hidden;
    margin-top: 60px;
    height: calc(100% - 60px - 102px);
    ${p => p.isEaster && css`
        margin-top: 140px;
        margin-left: 116px;
        margin-right: 88px;
        margin-bottom: 66px;
        height: calc(100% - 60px - 115px - 67px);
    `}
    ${p =>
        p.isLow
            ? css`
                  height: 330px;
                  width: 720px;
                  margin: auto;
                  margin-top: 120px;
                  border-radius: 30px;
                  border: 2px solid black;
                  -webkit-mask-image: -webkit-radial-gradient(white, black);
              `
            : undefined}
`;

export const EasterBackground = styled.div`
    background-image: url("${experienceEasterPath}/easter-score-background.svg");
    background-size: 100% 100%;
    position: absolute;
    top: 84px;
    left: 4px;
    right: -6px;
    bottom: 35px;
    z-index: -1;
`;

export const Asset1Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    pointer-events: none;

    img {
        width: 228px;
    }
`;

export const Asset2Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: 300px;
    pointer-events: none;
    img {
        width: 588px;
    }
`;

export const Asset3Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    pointer-events: none;
    img {
        width: 387px;
    }
`;

const padding = 20;
export const ChristmasBackground = styled.div`
    background-color: ${p => p.theme.c.christmasBlue};
    box-shadow: 0 0 0 6px ${p => p.theme.c.christmasLightBlue} inset;
    position: absolute;
    top: ${140 - padding}px;
    left: ${116 - padding}px;
    right: ${88 - padding}px;
    bottom: ${103 - padding}px;
    z-index: -1;
`;
